import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/img/apple.svg'
import _imports_1 from '@/img/bag.svg'


const _hoisted_1 = {
  key: 0,
  class: "box d-flex flex-column"
}
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "boxTitle" }
const _hoisted_4 = { class: "d-flex align-items-end mt-5" }
const _hoisted_5 = { class: "portafoglioLower mt-3" }
const _hoisted_6 = { class: "portafoglioItem" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "icon blue" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_8 = { class: "itemLabel" }
const _hoisted_9 = { class: "grosso" }
const _hoisted_10 = { class: "portafoglioItem" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "icon blue" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1)
const _hoisted_12 = { class: "itemLabel" }
const _hoisted_13 = { class: "grosso" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_month_navigator = _resolveComponent("month-navigator")!
  const _component_line_chart = _resolveComponent("line-chart")!

  return (_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_localized_text, {
                localizedKey: "Performance",
                text: "Performance"
              })
            ]),
            _createVNode(_component_month_navigator, {
              modelValue: _ctx.periodo,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.periodo) = $event)),
                _ctx.init
              ]
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_line_chart, {
            value: _ctx.earningsData,
            style: {"max-width":"720px","margin":"auto"},
            color: "#7B61FF"
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_localized_text, {
                localizedKey: "Personali",
                text: "Personali"
              })
            ]),
            _createElementVNode("div", _hoisted_9, "€ " + _toDisplayString(_ctx.$filters.currency(_ctx.personal)), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_localized_text, {
                localizedKey: "Dalla rete",
                text: "Dalla rete"
              })
            ]),
            _createElementVNode("div", _hoisted_13, "€ " + _toDisplayString(_ctx.$filters.currency(_ctx.network)), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}